import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { DocumentSection } from '../documents/DocumentSection';
import { Trans, useTranslation } from 'react-i18next';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
const PayInThreeInfo = () => {
  const $ = _c(43);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["pricing"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("products.payInThree.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconThird className="text-blue-500" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("products.table.1");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <td className="text-left">{t3}</td>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("products.payInThree.1");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <td className="text-right font-bold">{t5}</td>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <tr className="flex justify-between">{t4}{t6}</tr>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("products.table.2");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <td className="text-left">{t8}</td>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <br />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = <td className="text-right font-bold"><Trans t={t} i18nKey="products.payInThree.2">{t10}</Trans></td>;
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <tr className="flex justify-between">{t9}{t11}</tr>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("products.table.3");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <td className="text-left">{t13}</td>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("products.payInThree.3");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <td className="text-right font-bold">{t15}</td>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <tr className="flex justify-between">{t14}{t16}</tr>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t12 || $[37] !== t17 || $[38] !== t7) {
    t18 = <table className="w-full"><tbody className="space-y-4">{t7}{t12}{t17}</tbody></table>;
    $[36] = t12;
    $[37] = t17;
    $[38] = t7;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t1 || $[41] !== t18) {
    t19 = <DocumentSection title={t1} icon={t2} defaultOpen={false}>{t18}</DocumentSection>;
    $[40] = t1;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
};
export default PayInThreeInfo;